import React from 'react'
import TeamHero from './TeamHero'
import TeamText from './TeamText'
import TeamBody from './TeamBody'

const AboutOurTeam = () => {
  return (
    <>
    <div>
      <TeamHero/>
      <TeamText/>
    </div>
  
    <TeamBody/>
    </>
    )
}

export default AboutOurTeam

